import { useParams } from "react-router-dom";
import { useMatterType } from "../../../../contexts/MatterTypeContext";
import LoadingView from "../../../../components/LoadingView";
import { Heading } from "../../../../design/heading";
import EmptyStateView from "../../../../components/EmptyStateView";
import EventTypeListItem from "./EventTypeListItem";

const EventTypeList: React.FC = () => {
  const { matterTypeId } = useParams<{ matterTypeId: string }>();
  const { selectedMatterType, eventTypes, eventSubtypes } = useMatterType();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-end justify-between gap-4">
        <div className="flex flex-col gap-2">
          <Heading>Event Types</Heading>
        </div>
        <div className="flex gap-4"></div>
      </div>
      {selectedMatterType?.eventTypeTaskStatus === "processing" && (
        <LoadingView
          title="Processing Event Types..."
          message="Please give us a minute"
        />
      )}
      {selectedMatterType?.eventTypeTaskStatus !== "processing" &&
        eventTypes.length === 0 && (
          <EmptyStateView
            title="No Event Types"
            message="You have not created any event types yet."
            className="h-full"
          />
        )}
      {eventTypes.map((eventType) => (
        <EventTypeListItem
          key={eventType._id}
          matterTypeId={matterTypeId!}
          eventType={eventType}
          eventSubtypes={eventSubtypes}
        />
      ))}
    </div>
  );
};

export default EventTypeList;
